import { render, staticRenderFns } from "./channelDataTrend.vue?vue&type=template&id=35d96ad0"
import script from "./channelDataTrend.vue?vue&type=script&lang=js"
export * from "./channelDataTrend.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports